import React from "react";
import PropTypes from "prop-types";
import { useGSAP } from "@gsap/react";
import { useMediaQuery } from "react-responsive";
import { Sizes } from "../../styles";

import Timer from "./Timer";
import LineGraphic from "./LineGraphic";
import StarGraphic from "./StarGraphic";
import Partners from "./Partners";

import scaleUp from "../../animations/scaleUp";
import countUp from "../../animations/countUp";

const CountDownTimer = ({ date = "08/19/2025", title, lang, partners, partnersTagline }) => {
	useGSAP(() => {
		const scaleUpOptions = {
			trigger: ".count-down-timer",
			start: "top top+=200",
			delay: 0.2,
		};
		scaleUp(scaleUpOptions);
		countUp(".animate--count-up");
	});

	const decodedPartners = JSON.parse(partners);

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});


	return (
		<section
			className="count-down-timer alignfull"
			aria-labelledby="count-down-timer-title"
		>
			<div
				className="count-down-timer__white-curved-shape--top-left__container"
				aria-hidden="true"
			>
				<svg
					className="top-right-curve"
					viewBox="0 0 20 17"
					fill="white"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clipRule="evenodd"
						d="M19.5 0C19.5 9.56705 9.56705 16.2356 0 16.2356H19.5V0Z"
						fill="white"
					/>
				</svg>
				<div className="count-down-timer__white-curved-shape--top-left"></div>
				<svg
					className="bottom-left-curve"
					viewBox="0 0 22 29"
					fill="white"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clipRule="evenodd"
						d="M21.7256 0V28.5H9.15527e-05C12.9861 28.5 21.7256 12.986 21.7256 0Z"
						fill="white"
					/>
				</svg>
			</div>

			<StarGraphic className="count-down-timer__star-left animate--scale-up" />

			<div className="count-down-timer__header">
				{title && (
					<h1
						className="count-down-timer__header__title"
						id="count-down-timer-title"
					>
						{title}
					</h1>
				)}
				<h2 className="count-down-timer__header__subtitle">
					{lang == "en" ? "Coming soon" : "Bientôt disponible"}
				</h2>
			</div>

			<Timer date={date} lang={lang} />
			<LineGraphic />

			<StarGraphic className="count-down-timer__star-right animate--scale-up" />
			{
				isDesktopOrLaptop &&
				<StarGraphic className="count-down-timer__star-left-bottom animate--scale-up" />
			}

			<div
				className="count-down-timer__white-curved-shape--bottom-right__container"
				aria-hidden="true"
			>
				<svg
					className="top-right-curve"
					viewBox="0 0 20 17"
					fill="white"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clipRule="evenodd"
						d="M19.5 0C19.5 9.56705 9.56705 16.2356 0 16.2356H19.5V0Z"
						fill="white"
					/>
				</svg>
				<div className="count-down-timer__white-curved-shape--bottom-right">
					{
						isDesktopOrLaptop &&
						<Partners partners={decodedPartners} tagline={partnersTagline} />
					}
				</div>
				<svg
					className="bottom-left-curve"
					viewBox="0 0 22 29"
					fill="white"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clipRule="evenodd"
						d="M21.7256 0V28.5H9.15527e-05C12.9861 28.5 21.7256 12.986 21.7256 0Z"
						fill="white"
					/>
				</svg>
			</div>
			{
				!isDesktopOrLaptop &&
				<div className="count-down-timer__partners__container">
					<Partners partners={decodedPartners} tagline={partnersTagline} />
				</div>
			}
		</section>
	);
};

export default CountDownTimer;

CountDownTimer.propTypes = {
	date: PropTypes.string,
	title: PropTypes.string,
	lang: PropTypes.string,
	partners: PropTypes.string,
	partnersTagline: PropTypes.string,
};
